"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _styling = require("../../toolkit/styling");

var _Link = _interopRequireDefault(require("../button/Link"));

var _providers = require("../../toolkit/providers");

//
//  src/nav/Breadcrumbs.js
//  Project-Lego
//
//  Created by Mengyu Yuan on 1/30/19.
//  Copyright © 2019-present ContextLogic Inc. All rights reserved.
//

/* Lego Toolkit */

/* Lego Components */
// These strings are used for demo

/* eslint-disable local-rules/unwrapped-i18n */
var demoProps = {
  items: [{
    name: "Home",
    href: "/"
  }, {
    name: "Products",
    href: "/products"
  }]
};
var propDoc = {
  items: {
    description: "List of items that should appear in the breadcrumbs",
    type: "ReadonlyArray<BreadcrumbItem>",
    required: true
  }
};

var Breadcrumbs = function Breadcrumbs(props) {
  var className = props.className,
      style = props.style,
      items = props.items;
  var styles = useStylesheet();

  if (items.length == 0) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.root, className, style)
  }, items.map(function (crumb, i) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: crumb.name
    }, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      style: styles.crumb,
      href: crumb.href,
      onClick: crumb.onClick
    }, crumb.name), i != items.length - 1 && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _styling.css)(styles.divider)
    }, "/"));
  }));
};

Breadcrumbs.propDoc = propDoc;
Breadcrumbs.demoProps = demoProps;
var _default = Breadcrumbs;
exports["default"] = _default;

var useStylesheet = function useStylesheet() {
  var _useTheming = (0, _providers.useTheming)(),
      textLight = _useTheming.theme.textLight,
      fonts = _useTheming.fonts;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
      },
      crumb: {
        fontFamily: fonts.regular,
        fontSize: 14,
        color: textLight
      },
      divider: {
        padding: "0px 5px",
        cursor: "default",
        userSelect: "none"
      }
    });
  }, [fonts.regular, textLight]);
};